import React, { useState, useEffect, useRef } from 'react';
import Modal from 'react-modal';
import DatePicker from "react-datepicker";
import ru from "date-fns/locale/ru";
import "react-datepicker/dist/react-datepicker.css";
import { format } from "date-fns";

Modal.setAppElement('#root');

const FolderModal = ({ isOpen, onClose, onSubmit, initialName, headerText = '', paramtype = null, libcode = null }) => {
  const [folderName, setFolderName] = useState(initialName);

  const [selectedDate, setSelectedDate] = useState(null); // Для даты
  const inputContainerRef = useRef(null); // Создаем ref для div контейнера
  const [libraryOptions, setLibraryOptions] = useState([]);

  // Этот эффект нужен, чтобы сбрасывать или заполнять поля при каждом открытии модального окна
  useEffect(() => {
    if (!initialName) {
      setFolderName(''); 
      setSelectedDate(''); 
    }
    else {
      setFolderName(initialName);
      if (paramtype == 3) {
        setSelectedDate(initialName);
      }
    }
    if (libcode > 0) {
      fetch(`${process.env.REACT_APP_BASE_URL}/api/object_params/getParamsLib/${libcode}`) // Замените на свой URL
        .then(response => response.json())
        .then(data => setLibraryOptions(data))
        .catch(error => console.error('Ошибка при загрузке данных:', error));
    }
    console.log("initialName = " + initialName);
  }, [initialName, isOpen, libcode]);
  
  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(folderName);
    onClose();
  };

  const handleFieldChange = (e) => {
    /*const value = e.target.value;
    
    if (initialType === 'integer' || initialType === 'float') {
      // Допускаем только числовые значения
      const numericValue = value.replace(/[^0-9.]/g, ''); // Только цифры и точка для дробных
      setExtraField(numericValue);
    } else {
      // Разрешаем любые значения
      setExtraField(value);
    }*/
    if (paramtype) {
      if (paramtype == 1) {
        const inputValue = e.target.value;
        const numericValue = inputValue.replace(/[^0-9]/g, "");
        e.target.value = numericValue;
      }
      if (paramtype == 2) {
        const inputValue = e.target.value;
        // Используем регулярное выражение, которое позволяет только целые и дробные числа с точкой в качестве разделителя.
        const regex = /^\d*\.?\d*$/;
        if (!regex.test(inputValue)) {
          // Если ввод не соответствует регулярному выражению, убираем последний символ, чтобы запретить его ввод.
          e.target.value = inputValue.slice(0, -1);
        }
      }
    }
   // else {
      setFolderName(e.target.value);
    //}
  };

  const customStyles = {
    content: {
      width: '400px',
      height: '400px',
      margin: 'auto',
      padding: '20px',
      borderRadius: '10px',
    },
    overlay: {
      backgroundColor: 'rgba(0, 0, 0, 0.75)',
    },
  };

  return (
    <Modal isOpen={isOpen} onRequestClose={onClose} style={customStyles} contentLabel="Create Folder">
      <h2>{headerText}</h2>
      <form onSubmit={handleSubmit}>
        <div ref={inputContainerRef}>
          <label>Наименование:</label>
          
          {paramtype == 3 ? (
            <DatePicker
              selected={selectedDate}
              onChange={(date) => {setSelectedDate(date); setFolderName(date)}}
              placeholderText="Выберете дату"
              locale={ru} // Указываем русский язык для компонента DatePicker
              dateFormat="dd.MM.yyyy"
            />
          ) : libcode > 0 ? (
            <select
              value={folderName}
              onChange={(e) => setFolderName(e.target.value)}
              required
            >
              {libraryOptions.map((option, index) => (
                <option key={index} value={option.plcode}>
                  {option.plname}
                </option>
              ))}
            </select>
          ) : 
          (
            <input
              type="text"
              value={folderName}
              onChange={handleFieldChange}
              //required
            />
          )}
        </div>
        <button type="submit">Сохранить</button>
        <button type="button" onClick={onClose}>Отмена</button>
      </form>
    </Modal>
  );
};

export default FolderModal;
